import styled, { css } from 'styled-components';
import Select from '#/shared/components/Select';
import BaseDatePicker, {
  Styled as DatePickerClasses,
} from '#/trip-planner/components/DatePicker';
import BaseTimePicker, {
  Styled as TimePickerClasses,
} from '#/trip-planner/components/TimePicker';
import StyledSwitch from '#/shared/components/StyledSwitch';
import Button from '#/shared/components/Buttons';
import { focusStyle } from '#/shared/css/focus';

const dateTimeFieldWrapperStyle = css`
  margin: 6px 0 15px;
  width: 100%;
  font-size: 1.5em;
  background-color: ${({ theme }) => theme.dropDownContentBg};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.dropDownBorder};
`;

const dateTimeFieldStyle = css`
  background-color: transparent;
  color: ${props => props.theme.dropDownText};
  font-family: inherit;
  padding: 6px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const DateTimeSelectorBody = styled.div`
  color: ${props => props.theme.contentText};
  background-color: ${props => props.theme.contentBgWithCards};

  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  width: 100%;
  padding-top: 20px;

  input:focus {
    background-color: ${({ theme }) => theme.dropDownFocusBg};
    border-radius: 5px 5px 0 0;
  }
`;

export const DateTimeSelectorInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;

export const DateTimeFieldWrapper = styled.div`
  margin: 8px 0 15px;
`;

const labelFontStyle = css`
  font-size: 0.9rem;
  color: ${props => props.theme.dropDownLabelText};
`;

export const DateTimeLabel = styled.label`
  ${labelFontStyle};
  text-transform: uppercase;
`;

export const TimeZoneNotice = styled.div`
  ${labelFontStyle};
  margin-top: -0.5rem;
`;

// TODO: move this styling to this project's `Select` component so it can be
//  shared in other views while preserving the styling re-use that is present
//  across this form's fields
export const TravelPreferenceSelect = styled(Select)`
  ${dateTimeFieldWrapperStyle};

  & .tps__control {
    ${dateTimeFieldStyle};
    border-color: transparent;
    box-shadow: none;

    &.tps__control--is-focused {
      ${focusStyle({ type: 'default', important: true })}
      background-color: ${({ theme }) => theme.dropDownInputBg};
    }

    &:hover {
      border-color: transparent;
    }

    & .tps__value-container {
      padding: 0;

      & .tps__single-value {
        margin: 0;
        color: ${({ theme }) => theme.dropDownText};
      }

      & .tps__input-container {
        padding: 0;
        margin: 0;
      }
    }

    & .tps__indicator-separator {
      display: none;
    }

    & .tps__indicator {
      opacity: 1;
      padding: 0;
      fill: ${({ theme }) => theme.dropDownIndicator};
    }
  }

  & .tps__menu {
    position: absolute;
    top: calc(100% - 3px);
    left: -1px;
    width: calc(100% + 2px);
    border-radius: ${({ theme }) => theme.dropDownContentRadius};
    background-color: ${({ theme }) => theme.dropDownInputBg};
    box-shadow: ${({ theme }) => theme.dropDownContentShadow};
    border: 1px solid ${({ theme }) => theme.dropDownBorder};

    margin: 0;

    & .tps__menu-list {
      padding: 10px 0;

      & .tps__option {
        color: ${({ theme }) => theme.dropDownText};
        cursor: pointer;

        &.tps__option--is-focused {
          background-color: transparent;
          outline: 2px solid ${({ theme }) => theme.dropDownOptionSelected};
          outline-offset: -6px;

          .js-focus-visible &:not(.focus-visible) {
            outline: none;
          }
        }

        &:hover {
          background-color: ${({ theme }) => theme.dropDownOptionSelectedHover};
        }

        &.tps__option--is-selected {
          color: ${({ theme }) => theme.dropDownTextSelected};
          background-color: ${({ theme }) => theme.dropDownOptionSelected};
          outline-color: ${({ theme }) => theme.dropDownTextSelected};

          outline-width: 2px;
        }
      }
    }
  }
`;

export const NowModeSwitch = styled(StyledSwitch).attrs(() => ({
  height: 18,
  width: 36,
}))`
  margin: 0 0 15px 0;
`;

export const NowModeSwitchLabel = styled.label`
  color: ${props => props.theme.dropDownLabelText};
  font-size: 1rem;
  margin-left: 10px;
  cursor: pointer;
`;

export const TimePicker = styled(BaseTimePicker)`
  ${dateTimeFieldWrapperStyle};

  ${TimePickerClasses.TimeFieldContainer} {
    ${dateTimeFieldStyle};
  }
`;

export const DatePicker = styled(BaseDatePicker)`
  ${dateTimeFieldWrapperStyle};

  ${DatePickerClasses.DateFieldContainer} {
    ${dateTimeFieldStyle};

    & input:focus {
      background-color: transparent;
    }
  }
`;

export const InputButtonsSpacer = styled.div`
  height: 3em;
`;

export const PlanTripButton = styled(Button)`
  margin-bottom: 10px;
  align-self: center;
  width: 250px;
`;

export const SaveSettingsButton = styled(Button)`
  margin-bottom: 10px;
  align-self: center;
  width: 250px;
`;
